import React from 'react';
import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { ResizablePanel } from '@Shared.Angular/flowingly.components/ResizablePanel/ResizablePanel';
import { SmartSearchPanel } from './SmartSearchPanel';

type ResizableSmartSearchPanelProps = {
  onClose: () => void;
};

const ResizableSmartSearchPanel = ({
  onClose
}: ResizableSmartSearchPanelProps) => (
  <ResizablePanel>
    <SmartSearchPanel onClose={onClose} />
  </ResizablePanel>
);

export const SmartSearchPanelBridge = react2angular(ResizableSmartSearchPanel, [
  'onClose'
]);
